import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdCaption02 = (props) => {
  return <LSBdCaption02Wrapper {...props} />;
};

export default LSBdCaption02;

const LSBdCaption02Wrapper = styled(LineSeedKrBd)`
  font-size: 12px;
  font-weight: 700;
  line-height: 14.4px;
  letter-spacing: -0.3px;

  color: #222222;
`;
